import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { DashboardService } from '@app/_services/dashboard.service';
import { first } from 'rxjs/operators';
import { formatDate } from '@angular/common';


@Component({
  selector: 'app-superverifier-dashboard',
  templateUrl: './superverifier-dashboard.component.html',
  styleUrls: ['./superverifier-dashboard.component.css']
})
export class SuperverifierDashboardComponent implements OnInit {

  constructor(private dashboardService: DashboardService) { }

  // getRequestStatiticsResponse:RequestStatitics[]=[];
  getTopTenEmployerResponse: any;
  getRequestratioResponse: any;
  getYearRevenueResponse: any;
  getDisputeRatioResponse: any;
  getFinancialStatResponse: any;
  getOnlineVerifiers: any;
  yearNew: number;
  yearClosed: number;
  yearDisputes: number;
  weekNew: number;
  weekClosed: number;
  weekDisputes: number;
  monthNew: number;
  monthClosed: number;
  monthDisputes: number;
  firstDate: string;
  lastDate: string;
  selectYear: string;
  monthyear: any;
  monthyearFormat: string;
  datewise: string = formatDate(new Date, 'yyyy-MM-dd', 'en-US');
  statistics: any = true;
  // @Output() childButtonEvent = new EventEmitter();

  superverifier: any = true;
  
  ngOnInit(): void {
   
    var currentyear = (new Date()).getFullYear();

    var currentMonth = (new Date()).getMonth() + 1;
    var d = currentMonth + '/' + currentyear;
    var  currentMonth1=currentMonth.toString().length === 1 ? "0" + currentMonth : currentMonth;;
   
    this.monthyear =  this.monthyear = currentyear+'-'+currentMonth1;//'2021-05';
    this.selectYear = currentyear.toString();
    var date = new Date(), y = date.getFullYear(), m = date.getMonth();

    var firstDay = new Date(y, m, 1);
    var lastDay = new Date(y, m + 1, 0);
    this.firstDate = formatDate(new Date(firstDay), 'yyyy-MM-dd', 'en-US');
    this.lastDate = formatDate(new Date(lastDay), 'yyyy-MM-dd', 'en-US');

    console.log("firstDay response---", firstDay)
    console.log("lastDay response---", lastDay)

    this.dashboardService.getOnlineVerifiers(this.firstDate, this.lastDate)
      .pipe(first())
      .subscribe(
        data => {
          console.log("getOnlineVerifiers response---", data)
          this.getOnlineVerifiers = data.respData;
        },
        error => {
          console.log(error)
        }
      )

  }

  firstDateChange() {
    this.dashboardService.getOnlineVerifiers(this.firstDate, this.lastDate)
      .pipe(first())
      .subscribe(
        data => {
          console.log("getOnlineVerifiers response---", data)
          this.getOnlineVerifiers = data.respData;
        },
        error => {
          console.log(error)
        }
      )

  }
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }
  lastDateChange() {
    this.dashboardService.getOnlineVerifiers(this.firstDate, this.lastDate)
      .pipe(first())
      .subscribe(
        data => {
          console.log("getOnlineVerifiers response---", data)
          this.getOnlineVerifiers = data.respData;
        },
        error => {
          console.log(error)
        }
      )

  }
  changemonth() {
    var splitted = this.monthyear.split("-");
    var year = splitted[0];
    var month = splitted[1];
    this.monthyearFormat = month + '/' + year;
    //alert(month+'/'+year);
  }

  changedate() {
    this.datewise;
    //alert(this.datewise);

  }

  getTab(tab) {
    if(tab=='statistics')
    {
    this.statistics=true;
    }
    else
    {
      this.statistics=false;
    }
  }



}

